import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';
import omit from 'lodash/omit';

const EDIT_DEVICE_LOCATION_ID_SCHEMA = z.object({
  device_id: z.string(),
  location_id: z.string(),
});

export type EditDeviceLocationIdSchema = z.infer<typeof EDIT_DEVICE_LOCATION_ID_SCHEMA>;

/**@deprecated */
export const editDeviceLocationIdPromise = async (param: EditDeviceLocationIdSchema) => {
  try {
    const headers = getHeadersWithBearerToken();
    headers.append('Content-Type', 'application/json');

    if (!EDIT_DEVICE_LOCATION_ID_SCHEMA.safeParse(param).success) {
      console.error('Invalid Params');
      throw new Error('Invalid Params');
    }

    const response = await ky.patch(`${ENV.API_URL}/api/displays/${param.device_id}/`, {
      headers,
      body: JSON.stringify({
        payload: JSON.stringify(omit(param, ['device_id'])),
      }),
    });

    if (response.ok) {
      return true;
    }

    return false;
  } catch (error) {
    console.error('Error in editDeviceLocationIdPromise', error);
    throw new Error('Error in editDeviceLocationIdPromise');
  }
};
